import React from 'react';
import { FormattedMessage } from 'react-intl';

import { CardContent, Grid, Typography } from '@mui/material';
import { faFileArrowUp, faHandPointer } from '@fortawesome/free-solid-svg-icons';

import { TranslationKeys } from '../../../../../../translations';

import { ViewDialog } from '../../../../../../components';

import { CardStyled, FontAwesomeIconStyled, TypographyStyled } from './EmployeeCreationModeSelectorDialog.styles';

export const ADD_EMPLOYEE_MANUALLY_CARD_TEST_ID = 'add-employee-manually-card';
export const ADD_EMPLOYEE_FILE_UPLOAD_CARD_TEST_ID = 'add-employee-file-upload-card';

type EmployeeCreationModeSelectorDialogProps = {
  show: boolean;
  onClose: () => void;
  onOpenWizard: () => void;
  onOpenUploadFormDialog: () => void;
};

export const EmployeeCreationModeSelectorDialog = ({
  show,
  onClose,
  onOpenWizard,
  onOpenUploadFormDialog,
}: EmployeeCreationModeSelectorDialogProps) => {
  return (
    <ViewDialog
      closeButton={false}
      open={show}
      title={<FormattedMessage id={TranslationKeys.employees_add} />}
      onClose={onClose}
    >
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <CardStyled onClick={onOpenWizard} data-testid={ADD_EMPLOYEE_MANUALLY_CARD_TEST_ID}>
            <CardContent>
              <FontAwesomeIconStyled icon={faHandPointer} />
              <TypographyStyled variant="h5">
                <FormattedMessage id={TranslationKeys.employees_add_manually} />
              </TypographyStyled>
              <Typography variant="body1">
                <FormattedMessage id={TranslationKeys.employees_add_manually_description} />
              </Typography>
            </CardContent>
          </CardStyled>
        </Grid>
        <Grid item xs={6}>
          <CardStyled onClick={onOpenUploadFormDialog} data-testid={ADD_EMPLOYEE_FILE_UPLOAD_CARD_TEST_ID}>
            <CardContent>
              <FontAwesomeIconStyled icon={faFileArrowUp} />
              <TypographyStyled variant="h5">
                <FormattedMessage id={TranslationKeys.employees_add_fileUpload} />
              </TypographyStyled>
              <Typography variant="body1">
                <FormattedMessage id={TranslationKeys.employees_add_fileUpload_description} />
              </Typography>
            </CardContent>
          </CardStyled>
        </Grid>
      </Grid>
    </ViewDialog>
  );
};
